import React from 'react';
import { Row } from 'antd';
import errorImg from '../assets/images/404.svg';

const NotFound = () => (
    <div className="contactUsContainer">
        <Row justify="center">
            <div className="ant-result ant-result-404">
                <div className="ant-result-icon ant-result-image">
                    <img src={errorImg} width="252" height="294" alt="Not Found" />
                </div>
            </div>
        </Row>
    </div>
);

export default NotFound;
